export default {
    Root: '84072d60-c9f0-440e-bc9f-2caa4c58ef4f',
    Store: 'bf7a36fb-b1ba-407d-ad8c-5b9d563c4681',
    Partner: '1eb5ba2c-e7de-421f-9c8d-1baafb751fc7',
    Location: 'bddff1b2-ffc7-48f4-b193-d751b1845b0e',
    Retailer: '5275e264-c6e0-4ca4-ab25-cb4168348477'
};


// WEBPACK FOOTER //
// ./src/components/common/accounts-type.js